<template>
    <div class="pdf-zoom">
        <i class="el-icon-zoom-in" :disabled="isDisabled" @click.prevent.stop="zoomIn"></i>
        <i class="el-icon-zoom-out" :disabled="isDisabled" @click.prevent.stop="zoomOut"></i>
        <i class="el-icon-c-scale-to-original" :disabled="isDisabled" @click.prevent.stop="fitWidth"></i>
        <i class="el-icon-full-screen" :disabled="isDisabled" @click.prevent.stop="fitAuto"></i>
    </div>
</template>

<script>
export default {
    name: 'PDFZoom',

    components: {},

    props: {
        scale: {
            type: Number,
        },
        increment: {
            type: Number,
            default: 0.25,
        },
    },

    computed: {
        isDisabled() {
            return !this.scale;
        },
    },

    methods: {
        zoomIn() {
            this.updateScale(this.scale + this.increment);
        },

        zoomOut() {
            if (this.scale <= this.increment) return;
            this.updateScale(this.scale - this.increment);
        },

        updateScale(scale) {
            this.$emit('change', { scale });
        },

        fitWidth() {
            this.$emit('fit', 'width');
        },

        fitAuto() {
            this.$emit('fit', 'auto');
        },
    },
};
</script>
